import { Input } from "src/components/common/form/input";
import { ConfigProvider, Table } from "antd";
import antdTheme from "src/themes/antdTheme";
import { Error } from "src/components/common/form/error";
import { useFormContext } from "react-hook-form";
import { getUserType } from "src/utils/localStorageHelper";
import MaskedText from "src/components/common/masked-text/masked-text";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export const TransferAttendanceTable = ({ data, isLoading, isError }) => {
  const { register, formState } = useFormContext();

  return (
    <ConfigProvider theme={antdTheme}>
      <Table
        bordered
        dataSource={data || []}
        columns={[
          {
            title: "id",
            dataIndex: "id",
            key: "id",
            width: 50,
            render: (text, record, index) => {
              return index + 1;
            },
          },
          {
            title: "名前",
            dataIndex: ["member_classes", "member", "name"],
            key: "name",
            width: 125,
          },
          {
            title: "振替",
            dataIndex: "re_attendance_id",
            key: "re_attendance_id",
            width: 50,
            align: "center",
            render: (text, record, index) => {
              return (
                <div className="fw-bold">
                  {record.re_attendance_id ? "振" : ""}
                </div>
              );
            },
          },
          {
            title: "会員番号",
            dataIndex: "member_code",
            key: "member_code",
            width: 100,
            render: (text, record, index) => {
              return record.member_classes?.member?.member_code;
            },
          },
          {
            title: "級",
            dataIndex: "rank",
            key: "rank",
            width: 50,
            render: (text, record, index) => {
              return record.member_classes.class;
            },
          },
          {
            title: "級計",
            dataIndex: "rank_count",
            key: "rank_count",
            width: 50,
            render: (text, record, index) => {
              return record?.class_count || "";
            },
          },
          {
            title: "出席",
            dataIndex: "status",
            key: "status",
            width: 450,
            render: (text, record, index) => {
              return (
                <div className="d-flex flex-column align-items-center">
                  <div className="d-flex gap-2 justify-content-center attendnaces-radio-group w-100">
                    <Input
                      label="出席"
                      type="radio"
                      name={`attendances.${index}.status`}
                      value="attended"
                      registration={register(`attendances.${index}.status`)}
                    />
                    <Input
                      label="欠席"
                      type="radio"
                      name={`attendances.${index}.status`}
                      value="absent"
                      registration={register(`attendances.${index}.status`)}
                    />
                    {getUserType() === "admin" && (
                      <>
                        <Input
                          label="欠席-休館"
                          type="radio"
                          name={`attendances.${index}.status`}
                          value="absent_schcon"
                          registration={register(`attendances.${index}.status`)}
                        />

                        <Input
                          label="欠席-警報"
                          type="radio"
                          name={`attendances.${index}.status`}
                          value="absent_alert"
                          registration={register(`attendances.${index}.status`)}
                        />
                      </>
                    )}
                  </div>
                  <Error
                    errorMessage={
                      formState.errors?.attendances?.[index]?.status?.message
                    }
                  />
                </div>
              );
            },
          },
          {
            title: "長期休校者",
            dataIndex: "long_absence",
            key: "long_absence",
            render: (text, record) => {
              return (
                <div className="text-center">
                  {!!record.member_classes?.closed_flag && (
                    <FontAwesomeIcon icon={faCheck} className="text-success" />
                  )}
                </div>
              );
            },
          },
          {
            title: "申し送り事項",
            dataIndex: "notice",
            key: "notice",
            render: (text, record) => {
              return (
                <MaskedText
                  text={record?.member_classes?.member?.notice}
                  className="my-1"
                />
              );
            },
          },
        ]}
        loading={isLoading}
        rowKey="id"
        pagination={false}
        rowClassName={record => {
          if (record.member_classes?.closed_flag) {
            return "bg-light text-muted pe-none";
          }

          return "";
        }}
        locale={{
          emptyText: isError
            ? "出席状況の取得に失敗しました"
            : "出席状況がありません",
        }}
      />
    </ConfigProvider>
  );
};
